export default __webpack_public_path__ + "static/media/ringlets.652baff4.png";